
import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import Form from 'react-bootstrap/Form';
import { ListGroup, Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import moment from 'moment';






import ReactPaginate from 'react-paginate';

import PageTitle from '../../../jsx/layouts/PageTitle';
import Editable from '../../../jsx/pages/Editable';
import ClientUploadLogo from '../../../jsx/components/SuperAdmin/client/ClientUploadLogo';
import ClientEditModal from '../../../jsx/components/SuperAdmin/client/ClientEditModal';
import ClientAddModal from '../../../jsx/components/SuperAdmin/client/ClientAddModal';
import { getAllCategoryType, getAllUserCategory, getCategoryTypeById } from '../../../services/superadminService/CategoreyType';
import AddCategoryModal from './AddCategoryModal';
import AddSubCategoryModal from '../subCategory/AddSubCategoryModal';
import CategoryUpdateModal from './CategoryUpdateModal';
import ViewCategoryModal from './ViewCategoryModal';
import { categoryTypeConfig } from '../../../config/dynamicListConfig';

const CategoryTypeList = ({ categoryType, type }) => {
    const config = categoryTypeConfig[type];
    const {
        title,
        fetchListApi,
        fetchSelectListApi,
        fetchByIdApi,
        fetchCreateApi,
        userCategoryApi,
        categorySelectKey,
        fetchUpdate,
        addModal: AddModal,
        viewModal: ViewModal,
        updateModal: UpdateModal,
        categoryIdField,
        CategoryOptions,
        categoryLabel
    } = config;
   

    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [addCard, setAddCard] = useState(false);
    const [addsubCard, setAddsubCard] = useState(false);
    const [contents, setContents] = useState([]);
    const [clientData, setClientData] = useState([]);
    const [basicModal, setBasicModal] = useState(false);
    const [categoryViewList, setCategoryViewList] = useState({});
    const [showEditModal, setShowEditModal] = useState(false);
    const [clientId, setClientId] = useState(null);

    const [editContentId, setEditContentId] = useState(null);
    const [viewShowModal, setViewShowModal] = useState(false);
    const [categoryidList, setCategoryidList] = useState({});
    const [userCategory, setUserCategory] = useState([])

    // Edit function button click to edit
    const handleEditClick = (clientID) => {
        setShowEditModal(true)
        setClientId(clientID)
        CategoryListByIdApi(clientID)

    };

    // edit  data  
    const [editFormData, setEditFormData] = useState({
        name: '',
        department: '',
        gender: '',
        education: '',
        mobile: '',
        email: '',
    })

    //update data function
    const handleEditFormChange = (event) => {
        event.preventDefault();
        const fieldName = event.target.getAttribute('name');
        const fieldValue = event.target.value;
        const newFormData = { ...editFormData };
        newFormData[fieldName] = fieldValue;
        setEditFormData(newFormData);
    };

    // edit form data submit
    const handleFormSubmit = (event) => {
        event.preventDefault();
        const editedContent = {
            id: editContentId,
            name: editFormData.name,
            department: editFormData.department,
            gender: editFormData.gender,
            education: editFormData.education,
            mobile: editFormData.mobile,
            email: editFormData.email,
        }
        const newContents = [...contents];
        const index = contents.findIndex((content) => content.id === editContentId);
        newContents[index] = editedContent;
        setContents(newContents);
        setEditContentId(null);
        // setEditModal(false);
    }
    //Cencel button to same data
    const handleCancelClick = () => {
        setEditContentId(null);
    };

    const viewClientFun = (clientId) => {
        CategoryListByIdApi(clientId)
        setViewShowModal(true)
    }

    const OpenlogoupdateModal = (clientId) => {
        setClientId(clientId)

    }

    const getCategoryLabelFromId = (type, id) => {
  const config = categoryTypeConfig[type];
  const match = config.CategoryOptions.find(
    (option) => option.id === parseInt(id)
  );
  return match?.[config.categorySelectKey] || "N/A";
};


    const formatDate = (dateString) => {
        return moment(dateString).format('MMMM Do YYYY');
    }


    const CategoryListByIdApi = async (categoryId) => {
        try {
            const response = await fetchByIdApi(categoryId);
            setCategoryidList(response?.data?.data)

        } catch (error) {
            console.error('Login error:', error);
        }
    }

    const ClientListApi = async (perPage, currentPage) => {
        try {
            const response = await fetchListApi(perPage, currentPage);
            //console.log("responseClient===>", response.data.data);
            setClientData(response?.data?.data || []);

        } catch (error) {
            console.error('Login error:', error);
        }
    }

    const handlePageChange = (event) => {
        const selectedPage = event.selected + 1;
        setCurrentPage(selectedPage);
    };

    const getUserListApi = async () => {
        try {
            const response = await fetchSelectListApi();
            setUserCategory(response?.data?.data)

        } catch (error) {
            console.error('Login error:', error);
        }
    }
    useEffect(() => {
        getUserListApi();
    }, []);



    useEffect(() => {
        ClientListApi(perPage, currentPage);
    }, [perPage, currentPage,fetchListApi]);
    return (
        <>
            <PageTitle activeMenu="Table" motherMenu="Post" />
            <div className="col-12">


                <div className="card">
                    <div className="card-header d-flex">
                        <div>
                            <div className="input-group search-area">
                                <input type="text"
                                    className={`form-control `}
                                    placeholder="Search here..."
                                />
                                <span className="input-group-text" >
                                    <Link to={"#"}><i className="flaticon-381-search-2"></i></Link>
                                </span>
                            </div>
                        </div>
                        <div>
                            <Dropdown as={ButtonGroup}>
                                <Button variant="primary" onClick={() => setAddCard(true)}>Add Category  <i className="fa fa-plus"></i></Button>

                            </Dropdown>
                        </div>

                    </div>
                    <div className="card-body">
                        <div className="w-100 table-responsive">
                            <div id="example_wrapper" className="dataTables_wrapper">
                                <form onSubmit={handleFormSubmit}>
                                    <table id="example" className="display w-100 dataTable">
                                        <thead>
                                            <tr>
                                                {config.tableHeaders?.map((header, index) => (
                                                    <th key={index}>{header}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {clientData?.data?.length > 0 ? (
                                                clientData.data.map((data, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            {editContentId === data?.id ? (
                                                                <Editable
                                                                    editFormData={editFormData}
                                                                    handleEditFormChange={handleEditFormChange}
                                                                    handleCancelClick={handleCancelClick}
                                                                />
                                                            ) : (
                                                                <>
                                                                     <td>{index + 1 + (currentPage - 1) * perPage}</td>
                                                                    <td>{data?.category_name || "N/A"}</td>
                                                                    <td>{data?.user_category_main?.main_category_name || "N/A"}</td>
                                                                    <td>{data?.slug || "N/A"}</td>
                                                                    <td>{data?.active_status === "1" ? "Active" : data?.active_status === "0" ? "InActive" : "N/A"}</td>
                                                                    <td>{data?.updated_at ? formatDate(data.updated_at) : "N/A"}</td>

                                                                    <td>
                                                                        <div className="d-flex">
                                                                            <Link
                                                                                className="btn btn-secondary shadow btn-xs sharp me-2"
                                                                                onClick={(event) => handleEditClick(data?.id)}
                                                                            >
                                                                                <i className="fas fa-pen"></i>
                                                                            </Link>
                                                                            <Link
                                                                                className="btn btn-danger shadow btn-xs sharp me-2"
                                                                                onClick={() => viewClientFun(data?.id)}
                                                                            >
                                                                                <i className="fa fa-eye"></i>
                                                                            </Link>

                                                                        </div>
                                                                    </td>
                                                                </>
                                                            )}
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan="6" className="text-center">Data is not available</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <ReactPaginate
                    nextLabel="next >"
                    onPageChange={handlePageChange}
                    pageRangeDisplayed={8}
                    marginPagesDisplayed={7}
                    pageCount={Math.ceil(clientData?.total / perPage)}
                    previousLabel="< previous"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active"
                    renderOnZeroPageCount={null}
                     forcePage={currentPage - 1}
                />

            </div>

            <AddCategoryModal addCard={addCard} setAddCard={setAddCard} CategoryList={ClientListApi} userCategory={userCategory} CategoryOptions={CategoryOptions} fetchCreateApi={fetchCreateApi} categoryIdField={categoryIdField} categoryLabel={categoryLabel} setCurrentPage={setCurrentPage}/>
            <ViewCategoryModal viewShowModal={viewShowModal} setViewShowModal={setViewShowModal} categoryidList={categoryidList} config={config} />
            <CategoryUpdateModal showEditModal={showEditModal} setShowEditModal={setShowEditModal} ClientId={clientId} categoryViewList={categoryViewList} categoryidList={categoryidList} CategoryList={ClientListApi} userCategory={userCategory} fetchUpdate={fetchUpdate} categorySelectKey={categorySelectKey} CategoryOptions={CategoryOptions} categoryIdField={categoryIdField} categoryLabel={categoryLabel} setCurrentPage={setCurrentPage}/>
        </>
    )
}

export default CategoryTypeList